module.exports = __webpack_public_path__ + "img/calendario-preenchido.9ecd481f.svg";